<div class="heading"><h2 mat-dialog-title>{{ text || ('Eintrag "' + identifier + '" wirklich löschen?') }}</h2></div>
<button mat-icon-button mat-dialog-close class="close-button">
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content>
<mat-dialog-actions align="end" class="button-container">
  <button mat-button [mat-dialog-close]="true" color="primary" class="yes-button">Ja</button>
  <button mat-button [mat-dialog-close]="false" color="accent" class="no-button">Nein</button>
</mat-dialog-actions>
</mat-dialog-content>
